/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IEcommJobCardContainerData } from './ecomm-job-card-container.data';
import { IEcommJobCardContainerProps } from './ecomm-job-card-container.props.autogenerated';

export interface IEcommJobCardContainerViewProps extends IEcommJobCardContainerProps<IEcommJobCardContainerData> {
    slotItems: React.ReactNode;
    title: string;
    anchorID: string;
    EcommJobCardContainerStyle: any;
    EcommJobCardContainerTitleStyle: any;
}

/**
 *
 * EcommJobCardContainer component
 * @extends {React.PureComponent<IEcommJobCardContainerProps<IEcommJobCardContainerData>>}
 */
class EcommJobCardContainer extends React.PureComponent<IEcommJobCardContainerProps<IEcommJobCardContainerData>> {
    public render(): JSX.Element | null {
        const { slots, config } = this.props;

        const EcommJobCardContainerViewProps = {
            ...this.props,
            slotItems: slots && slots.jobCards && slots.jobCards.length > 0 && slots.jobCards.map((item: React.ReactNode, index: number) => this._getSlotItem(item, index)),
            title: config.title,
            anchorID: config.anchorID,
            EcommJobCardContainerStyle: {
                className: 'ecomm-job-card-container'
            },
            EcommJobCardContainerTitleStyle: {
                className: 'ecomm-job-card-container-title'
            }
        };

        return this.props.renderView(EcommJobCardContainerViewProps);
    }

    private _getSlotItem(item: React.ReactNode, index: number): React.ReactNode {
        return (
          <React.Fragment key={index}>
            {React.cloneElement(item as React.ReactElement)}
          </React.Fragment>
        );
    }
}

export default EcommJobCardContainer;